import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SpeakerIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 21.1 15.34",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 15.34),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/jsx("path", {
      d: "M12.49.68A1.41 1.41 0 0 0 11 .8l-6.24 4H1.92A1.42 1.42 0 0 0 .5 6.24V9.1a1.42 1.42 0 0 0 1.42 1.43h2.84l6.24 4a1.41 1.41 0 0 0 1.49.14 1.43 1.43 0 0 0 .78-1.28V1.95A1.43 1.43 0 0 0 12.5.68zM19.52 11.22a6.24 6.24 0 0 0 0-6.72M16.78 9.98a3.3 3.3 0 0 0 0-4.17M4.79 4.83v5.68"
    })
  });
};

export { SpeakerIcon };
//# sourceMappingURL=speaker.js.map
